import React from "react";
import { navigate } from "react-big-calendar/lib/utils/constants";
import cx from "classnames";
import PropTypes from "prop-types";
import ArrowLeft from "rialto-icons/ArrowLeft";
import ArrowRight from "rialto-icons/ArrowRightSmall";
import Link from "rialto-icons/Link";

import IconButton from "components/IconButton";
import { Translate } from "utils";

import EventFilter from "./EventFilter";

import styles from "./CalendarHeader.css";

const { t } = new Translate("Calendar");

const CalendarHeader = (props) => {
  const { calendarToken, label, onFilter, onNavigate, onView, selectedFilters, view } = props;
  const views = ["month", "week", "day"];
  const dimensions = {
    height: ".75rem",
    width: ".75rem",
  };

  const openCalendar = () =>
    window.open(
      `${apiUrl}${version}/events/ics?key=${calendarToken}`.replace(/https?:\/\//, "webcal://"),
      "_blank"
    );

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.left}>
          <IconButton
            dimensions={dimensions}
            icon={ArrowLeft}
            onClick={() => onNavigate(navigate.PREVIOUS)}
          />
          <button onClick={() => onNavigate(navigate.TODAY)}>{t("today")}</button>
          <IconButton
            dimensions={dimensions}
            icon={ArrowRight}
            onClick={() => onNavigate(navigate.NEXT)}
          />
        </div>
        <div className={styles.middle}>{label}</div>
        <div className={styles.right}>
          {views.map((v) => (
            <button
              className={cx({ [styles.active]: v === view })}
              key={v}
              onClick={() => onView(v)}
            >
              {t(v)}
            </button>
          ))}
        </div>
      </div>
      <div className={styles.bottom}>
        <EventFilter onFilter={onFilter} selectedFilters={selectedFilters} />
        <button className={styles.downloadBtn} onClick={openCalendar}>
          <Link size="small" />
          {t("download")}
        </button>
      </div>
    </div>
  );
};

CalendarHeader.propTypes = {
  calendarToken: PropTypes.string,
  label: PropTypes.string.isRequired,
  selectedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  view: PropTypes.string.isRequired,
  onFilter: PropTypes.func.isRequired,
  onNavigate: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
};

export default CalendarHeader;
